module.exports = __webpack_public_path__ + "img/java.2fb288aa.svg";